import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../';

const propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  btnOneText: PropTypes.string.isRequired,
  btnOneUrl: PropTypes.string.isRequired,
  btnTwoText: PropTypes.string.isRequired,
  btnTwoUrl: PropTypes.string.isRequired,
  variant: PropTypes.string
};

const Cta = ({ variant, title, text, btnOneText, btnOneUrl, btnTwoText, btnTwoUrl }) => (
  <section className={( variant ? `cta cta--${variant}` : 'cta' )}>
    <div className="cta__column-left">
      <h3 className="title title--cta">{title}</h3>
      <p className="text">{text}</p>
    </div>
    <div className="cta__column-right">
      <Button text={btnOneText} to={btnOneUrl} outline />
      <Button text={btnTwoText} to={btnTwoUrl} /> 
    </div>
  </section>
);

Cta.propTypes = propTypes;

export default Cta;



// WEBPACK FOOTER //
// ./src/components/sections/Cta.js